import {BaseContainerModel} from '../../base-container.model';
import {
  bl_aat_entitlement_auto_top_up_run_RowClass,
} from '../../../dbschema';

export class ClaimEntitlementAutoTopUpRunContainerModel extends BaseContainerModel {
  bl_aat_entitlement_auto_top_up_run: bl_aat_entitlement_auto_top_up_run_RowClass =
    new bl_aat_entitlement_auto_top_up_run_RowClass();
}
